export default {
    active_sessions: "Active sessions",
    ask_for_details_on_response: "Ask for details on response",
    browser: "Browser",
    browser_data: "Browser data",
    current_session: "Current session",
    delete_all_sessions_except_current: "Delete all sessions except current",
    delete_attachment: "Delete attachment",
    delete_signed: "Delete signed",
    failed_login_attempts: "Failed login attempts",
    finished_sessions: "Finished sessions",
    last_use: "Last use",
    login_attempt: "Login attempt",
    operating_system: "Operating system",
    password_expires_in_days: "Your password expires today | Your password expires in {day} | Your password expires in {day}",
    password_valid_until_note: "Current password is valid until:",
    question_for_women_only: "Question for women only",
    reset_questionnaire_fill: "Reset questionnaire fill",
    sessions: "Sessions",
    tell_more: "Tell more",
    wrong_password: "Wrong password",
    "2fa_failed": "Two-factor authentication failed"
}
